import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import type { GenericResponse } from '@/features/card/types/card.types';

export interface PasswordResetRequestPayload {
  email: string;
  type: string;
}

export interface PasswordResetConfirmPayload {
  token: string;
  new_password: string;
}

export const passwordResetService = {
  async requestPasswordReset(payload: PasswordResetRequestPayload): Promise<void> {
    return apiClient.post(API_ENDPOINTS.auth.forgotPassword, { data: { data: payload } });
  },

  async confirmPasswordReset(payload: PasswordResetConfirmPayload): Promise<void> {
    return apiClient.post(API_ENDPOINTS.auth.resetPassword, { data: { data: payload } });
  },

  async validateToken(token: string): Promise<GenericResponse> {
    return apiClient.post(API_ENDPOINTS.auth.validateToken, {}, { params: { reference: token } });
  },
};
